import { ERoutes } from 'common/entities/routes'

export default [
  {
    path: ERoutes.ID_MAGALU_MIGRATION_LOGIN,
    async lazy() {
      const { default: Component } = await import('pages/IdMagaluMigration/Login')
      return { Component }
    },
  },
  {
    path: ERoutes.ID_MAGALU_MIGRATION_REGISTER,
    async lazy() {
      const { default: Component } = await import('pages/IdMagaluMigration/Register')
      return { Component }
    },
  },
]
